import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.module.css';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/react-image-gallery/styles/css/image-gallery.css";

//Google fonts



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App/>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
